"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimTokenValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const constants_1 = require("@dzambalaorg/constants");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.claimTokenValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
    item: mui_inputs_asset_1.tokenAssetValidationSchema,
    endTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing")
        .test("is-valid", "form.validations.rangeUnderflow", (value) => {
        if (!value) {
            return false;
        }
        if (value === new Date(0).toISOString()) {
            return true;
        }
        return new Date(value).getTime() > new Date().getTime();
    }),
});
//# sourceMappingURL=validation.js.map